import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaShoppingCart, FaHeart, FaEye } from 'react-icons/fa';
import '../styles/Products.css';

const Products = ({ onAddToCart }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get('/api/products');
      const data = Array.isArray(response.data) ? response.data : [];
      setProducts(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching products:', error);
      setProducts([]);
      setLoading(false);
    }
  };

  const filteredProducts = filter === 'all'
    ? products
    : products.filter(p => p.category === filter);

  const handleQuickView = (product) => {
    setSelectedProduct(product);
  };

  const closeQuickView = () => {
    setSelectedProduct(null);
  };

  if (loading) {
    return (
      <section className="products" id="products">
        <div className="container">
          <div className="loading">Loading products...</div>
        </div>
      </section>
    );
  }

  return (
    <section className="products" id="products">
      <div className="container">
        <div className="section-title">
          <h2>Our Premium Products</h2>
          <p>Handpicked natural products for your health and wellness</p>
        </div>

        <div className="product-filters">
          <button
            className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
          >
            All Products
          </button>
          <button
            className={`filter-btn ${filter === 'ghee' ? 'active' : ''}`}
            onClick={() => setFilter('ghee')}
          >
            Desi Ghee
          </button>
          <button
            className={`filter-btn ${filter === 'honey' ? 'active' : ''}`}
            onClick={() => setFilter('honey')}
          >
            Honey
          </button>
          <button
            className={`filter-btn ${filter === 'shilajit' ? 'active' : ''}`}
            onClick={() => setFilter('shilajit')}
          >
            Shilajit
          </button>
          <button
            className={`filter-btn ${filter === 'oil' ? 'active' : ''}`}
            onClick={() => setFilter('oil')}
          >
            Oils
          </button>
        </div>

        {filteredProducts.length === 0 ? (
          <div className="no-products">
            <p>No products found. Please check back later!</p>
          </div>
        ) : (
          <div className="products-grid">
            {filteredProducts.map((product) => (
            <div key={product.id} className="product-card">
              {product.featured && <span className="featured-badge">Featured</span>}
              {!product.inStock && <span className="out-of-stock-badge">Out of Stock</span>}

              <div className="product-image">
                <img src={product.image} alt={product.name} />
                <div className="product-overlay">
                  <button className="icon-btn" onClick={() => handleQuickView(product)}>
                    <FaEye /> Quick View
                  </button>
                </div>
              </div>

              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-description">{product.description}</p>

                <div className="product-pricing">
                  <span className="current-price">Rs. {product.price}</span>
                  {product.originalPrice && (
                    <span className="original-price">Rs. {product.originalPrice}</span>
                  )}
                  {product.originalPrice && (
                    <span className="discount">
                      {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% OFF
                    </span>
                  )}
                </div>

                <div className="product-actions">
                  <button
                    className="btn btn-primary add-to-cart-btn"
                    onClick={() => onAddToCart(product)}
                    disabled={!product.inStock}
                  >
                    <FaShoppingCart /> {product.inStock ? 'Add to Cart' : 'Out of Stock'}
                  </button>
                  <button className="btn-icon wishlist-btn">
                    <FaHeart />
                  </button>
                </div>
              </div>
            </div>
            ))}
          </div>
        )}
      </div>

      {/* Quick View Modal */}
      {selectedProduct && (
        <div className="modal-overlay" onClick={closeQuickView}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeQuickView}>&times;</button>
            <div className="modal-grid">
              <div className="modal-image">
                <img src={selectedProduct.image} alt={selectedProduct.name} />
              </div>
              <div className="modal-details">
                <h2>{selectedProduct.name}</h2>
                <p className="modal-description">{selectedProduct.description}</p>

                <div className="modal-pricing">
                  <span className="current-price">Rs. {selectedProduct.price}</span>
                  {selectedProduct.originalPrice && (
                    <span className="original-price">Rs. {selectedProduct.originalPrice}</span>
                  )}
                </div>

                {selectedProduct.sizes && selectedProduct.sizes.length > 0 && (
                  <div className="size-options">
                    <label>Available Sizes:</label>
                    <div className="sizes">
                      {selectedProduct.sizes.map((size, index) => (
                        <span key={index} className="size-badge">{size}</span>
                      ))}
                    </div>
                  </div>
                )}

                <button
                  className="btn btn-primary modal-add-btn"
                  onClick={() => {
                    onAddToCart(selectedProduct);
                    closeQuickView();
                  }}
                  disabled={!selectedProduct.inStock}
                >
                  <FaShoppingCart /> Add to Cart
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Products;